export default __webpack_public_path__ + "static/media/zendesk-logo.54d5c9be.svg";